import { buildSnapshot } from './replay';
import { coverageFromDataCoverage, type CoverageState } from './coverage-state';
import { projectTimingRows, type TimingRow } from './timing-view';
import { capabilitiesForRecording, type RaceEvent, type RaceRecording, type RaceSnapshot, type SessionCapabilities } from './race';
import { raceRecords, type RaceRecords } from './records';
import { factsAt, type FactLedger } from './fact-ledger';

export interface SessionView {
  snapshot: RaceSnapshot;
  /** Normalized facts available to this runtime, retained for drill-downs. */
  facts: readonly RaceEvent[];
  timingRows: TimingRow[];
  records: RaceRecords;
  capabilities: SessionCapabilities;
  coverage: CoverageState;
}

/** The one read model consumed by dashboard panels at a cursor. */
export function projectSessionView(recording: RaceRecording, atMs: number, snapshotOverride?: RaceSnapshot, recordsOverride?: RaceRecords, ledger?: FactLedger): SessionView {
  // The runtime may already have a projected snapshot (for example the
  // official-result layer or the incremental live projector). Reusing it
  // keeps every panel on the exact same cursor and avoids building a second
  // competing snapshot inside the view layer.
  const snapshot = snapshotOverride ?? buildSnapshot(recording, atMs);
  const capabilities = capabilitiesForRecording(recording);
  const facts = ledger ? factsAt(ledger, snapshot.atMs) : recording.events.filter(event => event.atMs <= snapshot.atMs);
  return { snapshot, facts, timingRows: projectTimingRows(snapshot, capabilities), records: recordsOverride ?? raceRecords(snapshot, facts), capabilities, coverage: coverageFromDataCoverage(recording.durationMs, recording.coverage) };
}
